import { render, staticRenderFns } from "./CapituloUno18Page.vue?vue&type=template&id=0d8ac6cc"
import script from "./CapituloUno18Page.js?vue&type=script&lang=js&external"
export * from "./CapituloUno18Page.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports